module.exports = __webpack_public_path__ + "img/sld_scb_5_t1_b1_dark.33d98449.svg";